import { connect } from 'react-redux';
import { compose } from 'redux';
import Image from '../components/Image';
import onlyIf from '../hocs/onlyIf';
import { getOverlayFooterProps } from '../selectors/fixedArea';
function mapStateToProps(state, _a) {
    var screenID = _a.screenID, width = _a.width, height = _a.height, isCurrentScreen = _a.isCurrentScreen;
    return getOverlayFooterProps(state, screenID, width, height, isCurrentScreen);
}
var exists = function (_a) {
    var footer = _a.footer;
    return !!footer;
};
export default compose(connect(mapStateToProps), onlyIf(exists))(Image);
